import { render, staticRenderFns } from "./jobDescription.vue?vue&type=template&id=0955e606&"
import script from "./jobDescription.vue?vue&type=script&lang=js&"
export * from "./jobDescription.vue?vue&type=script&lang=js&"
import style0 from "./jobDescription.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports